import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import {noop} from 'lodash';
import {CreateEditControlModal} from '@ey/canvascoreservices';
import {currentResource} from '../../../util/utils';
import {entities as Entities} from '../../../util/uiconstants';
import {getControlById, updateControl} from '../../../actions/Control/controlaction';
import {getItApplications} from '../../../actions/ITApplication/itapplicationaction';
import {updateFormBodyRelatedObject} from '../../../actions/FormData/formdataactions';
import {getRelatedObjects, updateRelatedObject} from '../../../actions/RelatedObjects/relatedobjectsactions';
import {clearErrors} from '../../../actions/erroractions';
import Utility from '../../../util/utilityfunctions';

export default function CreateEditControlModalWrapper(props) {
	const {
		bodyId,
		controlId,
		documentId,
		wcgw,
		isCreate,
		isEdit,
		showModal,
		setShowModal,
		onClose,
		viewOnly = false
	} = props;

	const {engagementId, control, itApplications, relatedObjects} = useSelector((state) => {
		let relatedObjects = null;
		if (state.relatedObjects && state.relatedObjects.data && state.relatedObjects.data[Entities.Control]) {
			relatedObjects = state.relatedObjects.data[Entities.Control].byId[controlId];
		}

		return {
			engagementId: state.engagementId,
			control: state.controlsDetails,
			itApplications: state.itapplicationData,
			relatedObjects: relatedObjects
		};
	});

	const dispatch = useDispatch();

	const processAddChanges = (control) => {};

	const processEditChanges = (control) => {
		const controlData = {
			id: control.controlId,
			controlName: control.controlName,
			controlFrequencyTypeId: control.controlFrequencyTypeId,
			controlTypeId: control.controlTypeId,
			ITApplicationOrSOIds: control.itApplicationOrSOIds,
			controlDesignEffectivenessTypeId: control.controlDesignEffectivenessTypeId,
			isEffective: control.isEffective,
			hasControlTesting: control.hasControlTesting,
			isLowerRisk: control.isLowerRisk
		};

		const promise = dispatch(updateControl(engagementId, control.controlId, controlData));

		promise.then(() => {
			if (bodyId && bodyId > 0) {
				dispatch(
					updateFormBodyRelatedObject({
						...control,
						bodyId: bodyId,
						entityId: Entities.Control,
						entityUId: control.controlId,
						entityName: control.controlName,
						controlFrequencyTypeId: control.controlFrequencyTypeId,
						controlTypeId: control.controlTypeId,
						iTApplications: control.itApplicationOrSOIds,
						designEffectiveness: control.controlDesignEffectivenessTypeId,
						isEffective: control.isEffective,
						hasControlTesting: control.hasControlTesting,
						isLowerRisk: control.isLowerRisk
					})
				);
			} else {
				const model = {
					entityId: Entities.Control,
					id: control.controlId,
					entityName: control.controlName
				};

				dispatch(updateRelatedObject(model));
			}

			return Promise.resolve();
		});

		promise.then(() =>
			relatedObjects
				? dispatch(
						getRelatedObjects(engagementId, documentId, parentItem.documentEntityId, parentItem.entityId, parentItem.id)
				  )
				: noop
		);

		return promise;
	};

	return (
		<>
			{isCreate && (
				<CreateEditControlModal
					engagementId={Number(engagementId)}
					showModal={showModal}
					setShowModal={setShowModal}
					labels={currentResource.CreateEditControlLabels}
					wcgw={wcgw}
					itApplications={itApplications}
					createAction={processAddChanges}
					onClose={onClose}
					getAllITApplicationAction={() => getItApplications(Number(engagementId), {includeControl: true})}
					theme={Utility.getTheme()}
				/>
			)}
			{isEdit && (
				<CreateEditControlModal
					engagementId={Number(engagementId)}
					showModal={showModal}
					setShowModal={setShowModal}
					labels={currentResource.CreateEditControlLabels}
					controlId={controlId}
					control={control}
					wcgw={wcgw}
					itApplications={itApplications}
					editAction={processEditChanges}
					onClose={() => {
						dispatch(clearErrors());
						onClose?.();
					}}
					getAllITApplicationAction={() => getItApplications(Number(engagementId), {includeControl: true})}
					getControlById={() => getControlById(Number(engagementId), controlId, documentId, 'itapplications')}
					viewOnly={viewOnly}
					theme={Utility.getTheme()}
				/>
			)}
		</>
	);
}

CreateEditControlModalWrapper.propTypes = {
	isCreate: PropTypes.bool,
	isEdit: PropTypes.bool,
	showModal: PropTypes.bool.isRequired,
	setShowModal: PropTypes.func.isRequired,
	riskId: PropTypes.number,
	onClose: PropTypes.func,
	viewOnly: PropTypes.bool
};
